<template>
	<v-navigation-drawer
        v-model="drawer"
        fixed
        clipped
        width="230"
        class="grey lighten-2"
        app
    >
        <v-list dense class="grey lighten-2">
            <v-list-tile  to="/payslip/list"  v-if="allowed.indexOf('admin') == -1 || allowed.indexOf('uploader') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-tasks black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">My Payslip</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/payslip/thirteen_month/list" v-if="allowed.indexOf('admin') == -1 || allowed.indexOf('uploader') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-tasks black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">My Thirteen Month</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/payslip/upload-payslip" v-if="allowed.indexOf('admin') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-cloud-upload-alt black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Payslip</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/payslip/upload-payslip" v-else-if="allowed.indexOf('uploader') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-cloud-upload-alt black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Payslip</v-list-tile-title>
            </v-list-tile>

            <v-list-tile  to="/payslip/upload-thirteen-month" v-if="allowed.indexOf('uploader') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-regular fa-calendar black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Thirteenth Month</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/payslip/upload-thirteen-month" v-else-if="allowed.indexOf('admin') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-regular fa-calendar black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Thirteenth Month</v-list-tile-title>
            </v-list-tile>
            
            <v-list-tile  to="/payslip/upload-review" v-if="allowed.indexOf('uploader') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-chart-bar black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Review</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/payslip/upload-review" v-else-if="allowed.indexOf('admin') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-chart-bar black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Review</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/payslip/upload-review" v-if="allowed.indexOf('uploader') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-solid fa-piggy-bank black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Loan Balance</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/payslip/upload-review" v-else-if="allowed.indexOf('admin') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-solid fa-piggy-bank black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Upload Loan Balance</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/profile/user-profile">
                <v-list-tile-action>
                    <v-icon>fas fa-address-card black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">My Profile</v-list-tile-title>
            </v-list-tile>
            <v-list-tile  to="/user/list" v-if="allowed.indexOf('admin') > -1">
                <v-list-tile-action>
                    <v-icon>fas fa-address-book black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">User List</v-list-tile-title>
            </v-list-tile>


            <v-list-tile to="/signout">
                <v-list-tile-action>
                    <v-icon>fa-sign-out-alt black--text</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="black--text subheading">Logout</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
	
export default {

	created : function(){

		this.eventHub.$on("allowedNavigations", (data) => {
			this.allowed = data;
		});

        this.eventHub.$on("clickBurgerNav", () => {
            this.drawer = !this.drawer;
        });

	},

	data : function(){
		return {
			drawer : true,
			allowed : []
		}
	},

	methods : {

	}

};

</script>